import Icon from '@components/shared/Icon'

import styles from '@components/chat/styles/Head.module.css'

const ChatHead = ({
    icon,
    title,
    onClose,
    actionsLeft,
    actionsRight, }) =>

    <div className={styles.head}>
        <div className={styles.inner}>
            <span>{ icon } {title}</span>
            <span className={styles.close} onClick={onClose}><Icon>close</Icon></span>
        </div>

        { (actionsLeft || actionsRight) && (

            <div className={styles.actions}>
                { actionsLeft && (
                    <div>
                        { actionsLeft }
                    </div>
                )}

                { actionsRight && (
                    <div>
                        { actionsRight }
                    </div>
                )}
            </div>
        )}
    </div>

ChatHead.Button = ({ text, onClick, active }) =>
    <button onClick={onClick} className={active
        ? styles.abtn
        : styles.btn}>{text}</button>

export default ChatHead